const initialState = {
    isOpen: false,
};

const bottomSheetEditPersonalInfo = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_BOTTOM_SHEET_EDIT_PERSONAL_INFO':
            return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default bottomSheetEditPersonalInfo;
